export function getCurrentDateHour() {
  const date = new Date();
  const day = ("0"+date.getDate().toString()).substr(-2)
  const month = ("0"+(date.getMonth() + 1).toString()).substr(-2);
  const year = date.getFullYear();
  const hour = ("0"+date.getHours().toString()).substr(-2);
  const minutes = ("0"+date.getMinutes().toString()).substr(-2);
  const second = ("0"+date.getSeconds().toString()).substr(-2);
  return year+"-"+month+"-"+day+" "+hour+":"+minutes+":"+second;
}

export function getCurrentDate() {
  const date = new Date();
  const day = ("0"+date.getDate().toString()).substr(-2)
  const month = ("0"+(date.getMonth() + 1).toString()).substr(-2);
  const year = date.getFullYear();
  return day+"/"+month+"/"+year;
}

export function getCurrentMonthAndYear() {
  const date = new Date();
  const month = ("0"+(date.getMonth() + 1).toString()).substr(-2);
  const year = date.getFullYear();
  return ""+year+month;
}
